/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const overrideCreateBodyStartOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const overrideCreateBodyEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const overrideCreateBodySubstituteUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const overrideCreateBodyReasonMax = 1000;

export const overrideCreateBodyExpectedVersionExclusiveMin = 0;
export const overrideCreateBodyExpectedVersionMax = 9007199254740991;

export const OverrideCreateBody = zod.object({
  start: zod.union([
    zod.iso.datetime({ offset: true }).regex(overrideCreateBodyStartOneRegExp),
    zod.literal('now'),
  ]),
  end: zod.iso.datetime({ offset: true }).regex(overrideCreateBodyEndRegExp),
  substituteUserId: zod.uuid().regex(overrideCreateBodySubstituteUserIdRegExp),
  reason: zod.string().max(overrideCreateBodyReasonMax).optional(),
  expectedVersion: zod
    .int()
    .gt(overrideCreateBodyExpectedVersionExclusiveMin)
    .max(overrideCreateBodyExpectedVersionMax),
});

export type OverrideCreateBody = zod.input<typeof OverrideCreateBody>;
export type OverrideCreateBodyOutput = zod.output<typeof OverrideCreateBody>;
